// API client for frontend to communicate with backend

// In production, use relative paths (same origin)
// In development, use the backend URL
const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8080');

class ApiClient {
  async fetchExamples() {
    try {
      const response = await fetch(`${API_BASE_URL}/api/examples`);
      if (!response.ok) {
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          const error = await response.json();
          throw new Error(error.error || 'Failed to fetch examples');
        } else {
          throw new Error(`Server error: ${response.status} ${response.statusText}`);
        }
      }
      return await response.json();
    } catch (error) {
      if (error instanceof TypeError && error.message.includes('JSON')) {
        console.error('Error fetching examples:', error);
        throw new Error(`Unable to connect to backend server. Please ensure the backend is running on ${API_BASE_URL}`);
      }
      console.error('Error fetching examples:', error);
      throw error;
    }
  }

  async createCheckout(orderData) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/create-checkout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(orderData),
      });

      if (!response.ok) {
        // Check if response is JSON before parsing
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          const error = await response.json();
          throw new Error(error.error || 'Failed to create checkout');
        } else {
          // Response is not JSON (might be HTML error page)
          const text = await response.text();
          console.error('Non-JSON error response:', text);
          throw new Error(`Server error: ${response.status} ${response.statusText}. Please check if the backend server is running on ${API_BASE_URL}`);
        }
      }

      return await response.json();
    } catch (error) {
      // If it's a network error or JSON parse error, provide helpful message
      if (error instanceof TypeError && error.message.includes('JSON')) {
        console.error('Error creating checkout:', error);
        throw new Error(`Unable to connect to backend server. Please ensure the backend is running on ${API_BASE_URL}`);
      }
      console.error('Error creating checkout:', error);
      throw error;
    }
  }

  async getOrderStatus(orderId) {
    try {
      // Add cache-busting headers and timestamp to prevent 304 responses
      const response = await fetch(`${API_BASE_URL}/api/orders/${orderId}?t=${Date.now()}`, {
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      });
      if (!response.ok) {
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          const error = await response.json();
          throw new Error(error.error || 'Failed to fetch order status');
        } else {
          throw new Error(`Server error: ${response.status} ${response.statusText}`);
        }
      }
      return await response.json();
    } catch (error) {
      if (error instanceof TypeError && error.message.includes('JSON')) {
        console.error('Error fetching order status:', error);
        throw new Error(`Unable to connect to backend server. Please ensure the backend is running on ${API_BASE_URL}`);
      }
      console.error('Error fetching order:', error);
      throw error;
    }
  }
}

export default new ApiClient();
